const personAccessRejection = {
	name: 'Rejected Access',
	fields: {
		lastname: 'Name',
		hp_id: 'ERP Number',
		rejected_at: 'Rejected At',
		status: 'Status',
		open_since_days: 'Open Since',
		actions: 'Actions',
	},
}

export default personAccessRejection
